import { ColumnDefWithFilters, ColumnGroup } from '../types'
import { useSimpleColumns } from '../utils'

const collectionGroups: ColumnGroup[] = [
  {
    id: 'exalted',
    header: 'Reputations',
    subColumns: [
      {
        id: 'total_exalted',
        header: 'Exalted',
        field: 'exalted_amount',
      },
    ],
  },
  {
    id: 'renown',
    header: 'Renown',
    rankFields: null,
    subColumns: [
      {
        label: 'Silvermoon Court',
        value: 'silvermoon_court',
        max: 20,
      },
      {
        label: 'Amani Tribe',
        value: 'amani_tribe',
        max: 20,
      },
      { label: "Hara'ti", value: 'harati', max: 20 },
      { label: 'The Singularity', value: 'the_singularity', max: 20 },
      { label: "Zul'Jarra's Forces", value: 'zuljarras_forces', max: 20 },
    ].map((reputation) => ({
      id: reputation.value,
      header: reputation.label,
      field: `${reputation.value}_renown`,
      cellWrapper: (value) => (
        <span
          className={value === reputation.max ? 'text-success-foreground' : ''}
        >
          {value}
        </span>
      ),
    })),
  },
]

export const useReputationsColumns = (): ColumnDefWithFilters => {
  const columns = useSimpleColumns(collectionGroups)

  return { columns, initialSortBy: [{ id: 'total_exalted', desc: true }] }
}
